import api from "./api";
import { URL_APP_BASE_PATH } from "../configs/constants";

export class PreviewService {
  add = async (preview) => {
    const url = `${URL_APP_BASE_PATH}/preview`;
    try {
      const { data } = await api.post(url, preview);
      return data;
    } catch (err) {
      return null;
    }
  };
}

const previewService = new PreviewService();
export default previewService;
